// extracted by mini-css-extract-plugin
export default {"learnMoreText":"YK_keVZ","paragraph":"yUJ64pr","noMargin":"JNXtyb1"};